import {ReceiptType} from "../../../libs/enum/receipt-type.enum";

export class StatisticReceiptTypeCategoryDto {

  public readonly type!: ReceiptType;
  public readonly categoryId: string | undefined;
  public readonly categoryName: string | undefined;
  public readonly currencyCode!: string;
  public readonly count!: number;
  public readonly sumTotalNetAmount!: number;
  public readonly avgTotalNetAmount!: number;
  public readonly sumTotalGrossAmount!: number;
  public readonly avgTotalGrossAmount!: number;

  constructor(init?: Partial<StatisticReceiptTypeCategoryDto> | undefined) {
    Object.assign(this, init);
  }
}
